import { Button, defineStyle } from '@chakra-ui/react';
import { fetchTokens } from '../../api/fetchApiFns';
import { useAccount } from 'wagmi';
import React, { useEffect, useState } from 'react';
import { useAlert } from '../../hooks/useAlert';
import { DayByMs } from '../../constants/DayByMs';

const claimButtonStyle = defineStyle({
  mt: '4px',
  borderRadius: '12px',
  maxW: '316px',
  w: '100%',
  variant: 'outline',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '21px',
  transition: 'background, color',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease-in-out',
  _hover: {
    backgroundColor: 'green.100',
    color: 'black',
  },
});

type Props = {
  totalDailyLimit: string;
  userDailyLimit: string;
};

export const ClaimButton = React.memo(({ totalDailyLimit, userDailyLimit }: Props) => {
  const { isConnected, isConnecting, address } = useAccount();
  const [isDisabled, setIsDisabled] = useState(false);

  const handleAlert = useAlert();

  useEffect(() => {
    const claimDisableTime = localStorage.getItem('claimDisableTime');
    if (claimDisableTime && address) {
      const parsedClaimObj = JSON.parse(claimDisableTime);
      const currentAddressTime = parsedClaimObj[address];
      if (currentAddressTime) {
        if (+new Date() - +new Date(currentAddressTime) > DayByMs) {
          delete parsedClaimObj.address;
          localStorage.setItem('claimDisableTime', JSON.stringify(parsedClaimObj));
          setIsDisabled(false);
        } else setIsDisabled(true);
      } else setIsDisabled(false);
    }
  }, [address]);

  const handleClick = async () => {
    try {
      const message = await fetchTokens();
      if (typeof message === 'string') {
        handleAlert('success', message + '.');
        setIsDisabled(true);
        const claimObj = localStorage.getItem('claimDisableTime');
        if (address) {
          if (claimObj) {
            const parsedClaimObj = JSON.parse(claimObj);
            if (!parsedClaimObj[address]) {
              parsedClaimObj[address] = new Date().toString();
              localStorage.setItem('claimDisableTime', JSON.stringify(parsedClaimObj));
            }
          } else localStorage.setItem('claimDisableTime', JSON.stringify({ [address]: new Date().toString() }));
        }
      } else handleAlert('error', message.detail);
    } catch (error) {
      console.log(error);
      handleAlert('error', 'Failed to claim');
    }
  };

  return (
    <>
      <Button
        {...claimButtonStyle}
        onClick={handleClick}
        isDisabled={!isConnected || userDailyLimit === '0' || totalDailyLimit === '0' || isConnecting || isDisabled}
      >
        Claim
      </Button>
    </>
  );
});
